// @ts-nocheck
import { HighOrderFrequencyRegister } from "./registers/high-order-frequency-registers.js";
import { getLowerNibble, getUpperNibble } from "../helpers/binary-helpers.js";
import { SimpleByteRegister } from "../helpers/simple-byte-register.js";
export class Sound3 {
    frequencyTimer = 0;
    frequencyPeriod = 0;
    lengthTimer = 0;
    waveformRam = new Uint8Array(16);
    waveTablePosition = 0;
    nr30SoundOff = new SimpleByteRegister(0xff1a);
    nr31Length = new SimpleByteRegister(0xff1b);
    nr32OutputLevel = new SimpleByteRegister(0xff1c);
    nr33LowOrderFrequency = new SimpleByteRegister(0xff1d);
    nr34HighOrderFrequency = new HighOrderFrequencyRegister(0xff1e);
    isActive = false;
    // Live channel-on status for NR52 ($FF26) bit 2. See Sound1.isOn.
    get isOn() {
        return this.isActive;
    }
    writeNr34(value) {
        this.nr34HighOrderFrequency.value = value;
        if ((value & 0x80) !== 0) {
            this.playSound();
        }
    }
    // NR30 ($FF1A) write. The wave channel's DAC is NR30 bit 7 (it has no volume
    // envelope). Clearing it turns the DAC off, which disables the channel — so
    // NR52's status bit reflects it. See Sound1.writeNr12.
    writeNr30(value) {
        this.nr30SoundOff.value = value;
        if ((value & 0x80) === 0) {
            this.isActive = false;
        }
    }
    // Power-off clears the wave channel's control registers and silences it.
    // Wave RAM ($FF30-$FF3F) is deliberately NOT cleared — hardware preserves
    // it across a power cycle.
    powerOff() {
        this.isActive = false;
        this.nr30SoundOff.value = 0;
        this.nr31Length.value = 0;
        this.nr32OutputLevel.value = 0;
        this.nr33LowOrderFrequency.value = 0;
        this.nr34HighOrderFrequency.value = 0;
    }
    tick(cycles) {
        // NB: the channel is triggered solely by writeNr34 (matching sound 1/2/4).
        // The old code ALSO re-triggered here whenever NR34 bit 7 was still set,
        // double-triggering every note (a second wave-position/length reset one
        // tick after the write). Removed.
        this.frequencyTimer -= cycles;
        if (this.frequencyTimer <= 0) {
            this.frequencyTimer += this.frequencyPeriod;
            this.waveTablePosition++;
            if (this.waveTablePosition === 32) {
                this.waveTablePosition = 0;
            }
        }
    }
    playSound() {
        // Enable channel
        this.isActive = true;
        // Wave table starts over on trigger
        this.waveTablePosition = 0;
        // Initialize frequency
        this.frequencyPeriod = this.getFrequencyPeriod();
        this.frequencyTimer = this.frequencyPeriod;
        // Initialize length
        this.lengthTimer = 256 - this.nr31Length.value;
        // A trigger with the DAC off (NR30 bit 7 clear) does not enable the channel.
        if ((this.nr30SoundOff.value & 0x80) === 0) {
            this.isActive = false;
        }
    }
    clockLength() {
        if (!this.nr34HighOrderFrequency.isContinuousSelection) {
            this.lengthTimer--;
            if (this.lengthTimer === 0) {
                this.isActive = false;
            }
        }
    }
    shifts = [4, 0, 1, 2];
    getSample() {
        const isOutputEnabled = this.nr30SoundOff.value >> 7 === 1;
        if (!isOutputEnabled || !this.isActive) {
            return 0;
        }
        const memoryAddress = Math.floor(this.waveTablePosition / 2);
        const waveData = this.waveformRam[memoryAddress]; //memory.readByte(this.waveTableMemoryAddress + memoryAddress);
        const isHighNibble = (this.waveTablePosition & 1) === 0;
        const sample = isHighNibble ? getUpperNibble(waveData) : getLowerNibble(waveData);
        const volumeAdjustedSample = sample >> this.shifts[(this.nr32OutputLevel.value >> 5) & 0b11];
        return volumeAdjustedSample / 15;
    }
    getFrequencyPeriod() {
        const rawValue = this.nr33LowOrderFrequency.value | (this.nr34HighOrderFrequency.highOrderFrequencyData << 8);
        return (2048 - rawValue) * 2;
    }
}
//# sourceMappingURL=sound-3.js.map